import React, { useCallback } from "react";

import AntdCheckbox, {
  CheckboxProps as AntdCheckboxProps,
  CheckboxChangeEvent,
} from "antd/es/checkbox";

export interface CheckboxProps extends Omit<AntdCheckboxProps, "onChange"> {
  onChange?: (checked: boolean, event: CheckboxChangeEvent) => void;
}

const Checkbox = ({ onChange, ...props }: CheckboxProps) => {
  const handleChange = useCallback<NonNullable<AntdCheckboxProps["onChange"]>>(
    (e) => onChange && onChange(e.target.checked, e),
    [onChange]
  );

  return <AntdCheckbox {...props} onChange={handleChange} />;
};

export default Checkbox;
